import type { Exercise, PlannedExercise, WorkoutSet } from '../types.js';

export function createPrescribedSets(item: PlannedExercise, loadType?: Exercise['loadType']): WorkoutSet[] {
  const reps = item.repMin > 0 ? item.repMin : undefined;
  const prescribedLoad = item.suggestedWeight;
  return Array.from({ length: item.plannedSets }, (_, index) => {
    const set: WorkoutSet = {
      id: crypto.randomUUID(),
      setNumber: index + 1,
      setType: 'working',
      reps,
      rpe: undefined,
      completed: false,
      failed: false,
      toFailure: false,
    };
    if (prescribedLoad === undefined) return set;
    if (loadType === 'BODYWEIGHT_MINUS_ASSISTANCE') set.assistanceKg = prescribedLoad;
    else if (loadType === 'BODYWEIGHT_PLUS_WEIGHT') set.additionalWeightKg = prescribedLoad;
    else set.weightKg = prescribedLoad;
    return set;
  });
}

export function prescribedExerciseLabel(item: PlannedExercise): string {
  const parts: string[] = [];
  if (item.suggestedWeight !== undefined) parts.push(`${formatNumber(item.suggestedWeight)} кг`);
  if (item.repMax > 0) parts.push(`${item.repMin === item.repMax ? item.repMin : `${item.repMin}–${item.repMax}`} повт.`);
  if (item.targetRpeMin !== undefined) {
    parts.push(`RPE ${item.targetRpeMin}${item.targetRpeMax !== undefined && item.targetRpeMax !== item.targetRpeMin ? `–${item.targetRpeMax}` : ''}`);
  }
  parts.push(`отдых ${item.restSeconds} сек`);
  return parts.join(' · ');
}

function formatNumber(value: number): string {
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value);
}
